import { createApp } from 'vue';
import { initIcons } from './icons';
import App from './App.vue';
import { serviceRegistry } from '@arcual/lib-app-platform';
import router from './router';
import { i18n } from './i18n';
import { createPinia } from 'pinia';
import VueGtag from 'vue-gtag';
import Hotjar from 'vue-hotjar';
import { env } from '@/constants';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createHead } from '@unhead/vue';
import { PlatformHttpServiceConfiguration } from '@/services/PlatformHttpServiceConfiguration';
import * as Sentry from '@sentry/vue';
import { registerSW } from 'virtual:pwa-register'

serviceRegistry.initServices(new PlatformHttpServiceConfiguration());
initIcons();

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const app = createApp(App);

const head = createHead();
app.use(head);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const updateSW = registerSW({ immediate: true })
app.use(updateSW)

app.use(pinia);
app.use(router);
app.use(i18n);

app.use(
  VueGtag,
  {
    disableScriptLoad: false,
    config: {
      id: 'G-531C3PMK93',
    },
    enabled: env.VITE_ENV === 'production',
  },
  router,
);
app.use(Hotjar, {
  id: '4944850', // Hotjar Site ID
  isProduction: env.VITE_ENV === 'production',
});

if (env.VITE_FEATURE_SENTRY_ENABLED) {
  const integrations = [Sentry.browserTracingIntegration(), Sentry.replayIntegration()];

  if (env.VITE_FEATURE_SENTRY_CUSTOMER_FEEDBACK_ENABLED) {
    integrations.push(
      Sentry.feedbackIntegration({
        colorScheme: 'system',
        showBranding: false,
        isEmailRequired: true,
        autoInject: false,
      }),
    );
  }

  const sentryConfig = {
    app,
    dsn: env.VITE_SENTRY_INGEST_URL,
    environment: env.VITE_ENV,
    release: env.VITE_PACKAGE_VERSION,
    integrations,
    // Performance Monitoring
    tracesSampleRate: 0.1, //  Capture 10% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/platform-api.*\.arcual\.art/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  };

  Sentry.init(sentryConfig);
}

serviceRegistry.initAuthentication();

app.mount('#app');

console.info(`v${env.VITE_PACKAGE_VERSION}`);
